import { SettingsInterface } from 'client/Interfaces/Settings/SettingsInterface'
// typescript
import { QuotaTypes, SubscriptionInterface } from 'client/Interfaces/Subscription'
import {
  ISubscriptionFeatureList,
  SubscriptionFeatureCheckboxType,
} from 'client/Interfaces/Subscription/ISubscriptionFeatureList'
import { hasModuleAvailable, moduleNames } from 'client/reducers/settings'
import { setBaseClass } from 'client/utils'
import * as React from 'react'

import { ISubscriptionPremiumPlanOptionsPropsInterface } from '../IPremiumInterface'
import './FeatureList.scss'
// components
import FeaturesSection from './FeaturesSection'

interface IFeatureListSeperatorLine {
  highlights: ISubscriptionFeatureList['highlights']
  drawSeparationLine: ISubscriptionFeatureList['drawSeparationLine']
}

export interface IPremiumPlanModalStateProps {
  getPlansOnGoing?: boolean
  subscription?: SubscriptionInterface
  dateFormat?: string
  isActionLoading?: boolean
  locale?: string
  isAvailablePlansLoaded: boolean
}

type TFeatureList = Pick<
  ISubscriptionPremiumPlanOptionsPropsInterface,
  'isCombinedPlan' | 'onSelectCombinedPlan' | 'selectedPlanName' | 'selectableAvailablePlans'
>
interface IFeaturesList extends TFeatureList {
  billingCycle: 'month' | 'year'
  items: ISubscriptionFeatureList['items']
  highlights: ISubscriptionFeatureList['highlights']
  drawSeparationLine: IFeatureListSeperatorLine['drawSeparationLine']
  features: ISubscriptionFeatureList
  className?: string
  settings: SettingsInterface
  allPlans
  processingPlanName?: string
}

const cls = setBaseClass('SubscriptionFeatureList')

const FeaturesListSeperatorLine = (props: IFeatureListSeperatorLine) => {
  if (props.highlights) {
    if (props.drawSeparationLine) {
      return <div className={cls('__line')} />
    }
    return <div className={cls('__spacing')} />
  }

  return null
}

const filterFeatures = (items: ISubscriptionFeatureList['items'], settings: SettingsInterface) => {
  const isBankingAvailable = settings && hasModuleAvailable(settings, moduleNames.banking)
  const isTinkPaymentAvailable = settings && hasModuleAvailable(settings, moduleNames.tinkPayment)
  let filteredItems = [...items]
  if (!isBankingAvailable && settings) {
    filteredItems = filteredItems.filter((item) => !item.translationKeyMonth.includes(QuotaTypes.BANKING))
  }
  if (!isTinkPaymentAvailable && settings) {
    filteredItems = filteredItems.filter((item) => !item.translationKeyMonth.includes(QuotaTypes.ONLINE_BANK_PAYMENTS))
  }
  return filteredItems
}

class FeatureList extends React.Component<IFeaturesList> {
  public render() {
    const {
      selectedPlanName,
      highlights: featureHighlights,
      items: featureItems,
      drawSeparationLine,
      selectableAvailablePlans,
      billingCycle,
      isCombinedPlan,
      onSelectCombinedPlan,
      className,
      settings,
      allPlans,
      processingPlanName,
    } = this.props

    const mainClass = [cls()]

    if (className) {
      mainClass.push(className)
    }

    const filteredItems = filterFeatures(featureItems, settings)
    return (
      <div className={mainClass.join(' ')}>
        {featureHighlights?.length !== 0 && (
          <FeaturesSection
            isCombinedPlan={isCombinedPlan}
            selectedPlanName={selectedPlanName}
            onSelectCombinedPlan={onSelectCombinedPlan}
            selectableAvailablePlans={selectableAvailablePlans}
            features={featureHighlights}
            classProps={{ '--highlighted-items': true }}
            billingCycle={billingCycle}
            allPlans={allPlans}
            processingPlanName={processingPlanName}
          />
        )}
        <FeaturesListSeperatorLine drawSeparationLine={drawSeparationLine} highlights={featureHighlights} />
        {filteredItems && (
          <FeaturesSection
            features={filteredItems}
            classProps={{ '--items': true }}
            billingCycle={billingCycle}
            allPlans={allPlans}
          />
        )}
      </div>
    )
  }
}

export default FeatureList
